// extracted by mini-css-extract-plugin
export var attribution = "_b9-4";
export var authorName = "_b9-5";
export var quote = "_b9-3";
export var testimonial = "_b9-2";
export var trustedBy = "_b9-0";
export var trustedByLabel = "_b9-1";